/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { ActionLinkColumn, TextColumn } from '@veeam-vspc/components';

import { JobTypes } from 'core/enums';
import { useLang } from 'views/providers/LangProvider/hooks';
import { FileServersDialog } from './components';

export interface FileServerColumnProps {
    value: any;
    jobType: JobTypes;
    name: string;
    instanceUid: string;
    stateId: string;
    alignRight?: boolean;
}

export const FileServerColumn: React.FC<FileServerColumnProps> = (props) => {
    const {
        value,
        jobType,
        name,
        instanceUid,
        stateId,
        alignRight = false,
    } = props;
    const lang = useLang();
    const content = value && ![JobTypes.FileCopy, JobTypes.FileTapeBackup].includes(jobType) ? value : null;

    return (
        <ActionLinkColumn
            renderContent={() => (
                <TextColumn style={{ color: 'inherit' }}>
                    {content}
                </TextColumn>
            )}
            isLink={Boolean(content)}
            isExtMode={true}
            alignRight={alignRight}
            renderModal={({ deactivate }) => (
                <FileServersDialog
                    deactivate={deactivate}
                    title={`${name} - ${lang.FILE_SHARE_BACKUP}`}
                    jobUid={instanceUid}
                    stateId={stateId}
                />
            )}
        />
    );
};
